import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list.
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    // `initialized` is the progressive-enhancement flag that load-more-controls.liquid
    // gates on: until it lands, the Load more button stays display:none and the numeric
    // page links stay visible, so a no-JS visitor always gets working pagination.
    //
    // PaginatedList does NOT set it in connectedCallback — it only re-asserts it later,
    // from the morph/update path, which never runs on a first paint. results-list.js sets
    // it itself for the same reason. Without this line the blog listing booted fine but
    // permanently displayed the no-JS numeric fallback instead of the Load more button.
    this.setAttribute('initialized', '');
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
